import React, { useEffect, useState } from "react";
import { apiClient } from "@/lib/api";
import { ddmmmyy } from "@/lib/format";

const AuditTrail = () => {
  const [data, setData] = useState({ rows: [], total: 0 });
  const [page, setPage] = useState(1);

  useEffect(() => {
    apiClient.get("/audit", { params: { page, page_size: 50 } })
      .then(({ data }) => setData(data));
  }, [page]);

  const lastPage = Math.max(1, Math.ceil((data.total || 0) / 50));

  return (
    <div>
      <div className="mb-6">
        <div className="text-xs uppercase tracking-widest text-gray-500 mb-1">Compliance</div>
        <h1 className="text-2xl font-bold text-[#0F2044]">Audit trail</h1>
      </div>

      <div className="bg-white rounded-md overflow-hidden" style={{ border: "1px solid var(--color-border)" }} data-testid="audit-list">
        <div className="overflow-x-auto">
          <table className="dr-table w-full text-sm">
            <thead>
              <tr>
                <th>Timestamp</th>
                <th>User</th>
                <th>Action</th>
                <th>Session ref</th>
                <th>Detail</th>
                <th>IP</th>
              </tr>
            </thead>
            <tbody>
              {data.rows.map((r) => (
                <tr key={r.id}>
                  <td className="uppercase-date">{ddmmmyy(r.timestamp)} <span className="text-gray-400">{(r.timestamp || "").slice(11, 19)}</span></td>
                  <td className="font-mono text-xs">{r.username}</td>
                  <td><span className="text-xs font-semibold uppercase tracking-wide text-[#0F2044]">{r.action}</span></td>
                  <td className="font-mono text-xs">{r.session_ref || "—"}</td>
                  <td className="text-xs text-gray-600">{r.detail}</td>
                  <td className="font-mono text-xs text-gray-400">{r.ip}</td>
                </tr>
              ))}
              {!data.rows.length && (
                <tr><td colSpan="6" className="text-center text-gray-500 py-8">No audit entries</td></tr>
              )}
            </tbody>
          </table>
        </div>
        <div className="flex justify-between items-center px-4 py-3 text-xs text-gray-500" style={{ borderTop: "1px solid var(--color-border)" }}>
          <span>Page {page} of {lastPage} · {data.total} records</span>
          <div className="flex gap-2">
            <button disabled={page <= 1} onClick={() => setPage(page - 1)}
                    className="px-3 py-1 rounded border disabled:opacity-40"
                    style={{ borderColor: "var(--color-border)" }}>Prev</button>
            <button disabled={page >= lastPage} onClick={() => setPage(page + 1)}
                    className="px-3 py-1 rounded border disabled:opacity-40"
                    style={{ borderColor: "var(--color-border)" }}>Next</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuditTrail;
